/**
 * DashboardSmartWidgets — bundles the 3 "smart" widgets that share lifecycle
 * concerns (admin-only, real-time, AI-driven). Extracted from DashboardPage.jsx
 * to keep that file's per-widget surface lean.
 *
 * Each child widget self-hides when it has nothing to show:
 *   • ActivityDigestWidget — hides on zero events
 *   • MatchQualityWidget — hides on zero matching activity
 *   • RealtimeActivityWidget — hides until any WS event arrives
 */
import ActivityDigestWidget from '@/components/dashboard/ActivityDigestWidget';
import MatchQualityWidget from '@/components/dashboard/MatchQualityWidget';
import RealtimeActivityWidget from '@/components/dashboard/RealtimeActivityWidget';
import SupplierReconciliationHealthWidget from '@/components/dashboard/SupplierReconciliationHealthWidget';

export default function DashboardSmartWidgets() {
  return (
    <>
      <SupplierReconciliationHealthWidget />
      <ActivityDigestWidget />
      <MatchQualityWidget />
      <RealtimeActivityWidget />
    </>
  );
}
